// extracted by mini-css-extract-plugin
export var container = "tag-page-module--container--4orod";
export var empty = "tag-page-module--empty--hWZ5C";
export var heading = "tag-page-module--heading--wor6n";